import i18n from '@/i18n'
import {
  ValidationProvider as _ValidationProvider,
  ValidationObserver as _ValidationObserver,
  extend,
} from 'vee-validate'
import {
  required,
  email,
  max,
  confirmed,
  min_value,
  max_value,
} from 'vee-validate/dist/rules'
import { isAvailableCountryCode } from './countries'

extend('required', {
  ...required,
  message: String(i18n.t('inputValidationMessageRequired')),
})

extend('email', {
  ...email,
  message: String(i18n.t('inputValidationMessageEmail')),
})

extend('max', {
  ...max,
  message: (_, { length }) =>
    String(i18n.t('inputValidationMessageMax', { characters: length })),
})

extend('confirmed', {
  ...confirmed,
  message: String(i18n.t('inputValidationMessageConfirmed')),
})

extend('country_region', {
  validate(value) {
    return isAvailableCountryCode(value)
  },
  message: String(i18n.t('inputValidationMessageCountryRegion')),
})

extend('min_value', {
  ...min_value,
  message: (_, { length }) =>
    String(i18n.t('inputValidationMessageMinValue', { characters: length })),
})

extend('max_value', {
  ...max_value,
  message: (_, { length }) =>
    String(i18n.t('inputValidationMessageMaxValue', { characters: length })),
})

extend('jasrac_code', {
  validate(value) {
    const regex = /^[0-9]{1}[0-9a-zA-Z]{1}[0-9]{6}$/
    return regex.test(value)
  },
  message: String(i18n.t('inputValidationMessageJasracCode')),
})

extend('nextone_code', {
  validate(value) {
    const regex = /^N[0-9]{8}$/
    return regex.test(value)
  },
  message: String(i18n.t('inputValidationMessageNextoneCode')),
})

extend('artist_name_long', {
  validate(value) {
    return value.length <= 500
  },
  message: String(i18n.t('inputValidationMessageArtistNameLong')),
})

extend('work_title_long', {
  validate(value) {
    return value.length <= 500
  },
  message: String(i18n.t('inputValidationMessageWorkTitleLong')),
})

// for use in templates
export const ValidationProvider = _ValidationProvider
export const ValidationObserver = _ValidationObserver
